// extracted by mini-css-extract-plugin
export default {"list-unstyled":"List_list-unstyled__tx75i","item-spacing":"List_item-spacing__RaXSC"};